import actionTypes from './actionTypes.js';
import namespace from './namespace';
export default {
  namespace,
  state: {
    menuList: [{
      name: '首页',
      path: '/lib/subject'
    }, {
      name: '发现课程',
      path: '/lib/subject'
    }, {
      name: '公开课',
      path: '/lib/subject'
    }, {
      name: '题库',
      path: '/lib/subject'
    }, {
      name: '问答社区',
      path: '/lib/subject'
    }, {
      name: '课程包',
      path: '/lib/subject'
    }],
    subjectAuth: [],
    flagHideFoot: false,
    flagHideHead: false,
    currentUserInfo: [],
    doctitleConfig: {},
    schoolId: '',
    navConfig: {
      headTemplateId: 3
    },
    menusList: [],
    applyProvinceObj: {
      children: '',
      value: ''
    },
    isHideSepBtn: 0,
    // 快速做题权限 1-隐藏，0-不隐藏
    timeZoneFlag: false // 时区是否开启 true 开始 false 未开启

  },
  reducers: {
    [actionTypes.GET_MENU_ARR](state, action) {
      return { ...state,
        menuList: action.data
      };
    },

    [actionTypes.GET_SUBJECT_AUTH](state, action) {
      return { ...state,
        subjectAuth: action.data
      };
    },

    [actionTypes.FLAG_HIDE_FOOT](state, action) {
      return { ...state,
        flagHideFoot: action.data
      };
    },

    [actionTypes.FLAG_HIDE_HEAD](state, action) {
      return { ...state,
        flagHideHead: action.data
      };
    },

    [actionTypes.GET_CURRENT_USERINFO](state, action) {
      return { ...state,
        currentUserInfo: action.data
      };
    },

    [actionTypes.GET_DOCTITLE_INFO](state, action) {
      return { ...state,
        doctitleConfig: action.data
      };
    },

    [actionTypes.GET_SCHOOL_ID](state, action) {
      return { ...state,
        schoolId: action.data
      };
    },

    [actionTypes.NAV_CONFIG](state, action) {
      return { ...state,
        navConfig: action.data
      };
    },

    [actionTypes.SET_MENUS](state, action) {
      window.menusList = action.data;
      return { ...state,
        menusList: action.data
      };
    },

    [actionTypes.APPLY_PROVINCE](state, action) {
      return { ...state,
        applyProvinceObj: action.data
      };
    },

    [actionTypes.CHECK_SEPP_AUTH](state, action) {
      return { ...state,
        isHideSepBtn: action.data
      };
    },

    [actionTypes.TIME_ZONE_FLAG](state, action) {
      return { ...state,
        timeZoneFlag: action.data
      };
    }

  }
};